import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'booking_date': 'String',
	'kind': 'String',
	'building_guid': 'String',
	'floor_guid': 'String',
	'room_guid': 'String',
	'timeslot_guid': 'String!',
	
	//'transport_kind': 'String',
	//'building_parking_space_guid': 'String',
};

export default gql(`
	query timeslot_capacity( ${ HelperGraphql.createFields( fields ) } ) {
		timeslot_capacity( ${ HelperGraphql.createVariables( fields ) } ) {
			timeslot_guid
			date
			capacity
			remaining
			bookings
			block_comment
			exception_kind
			
			employee_did_book
			employee_is_inviter
			employee_is_invited
			employee_booking_status
			is_invitation
			invitation_guid
			
			timeslot_can_book_from
			timeslot_can_book_until
			timeslot_can_cancel_until
			
			employee_favourites
			employee_favourites_names
	    }
	}
`);
